/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagTagidLangs200,
  GetApiV1TagTagidLangs401,
  GetApiV1TagTagidLangs404,
  GetApiV1TagTagidLangs500,
  GetApiV1TagTagidLangsPathParams,
  GetApiV1TagTagidLangsQueryParams,
  GetApiV1TagTagidLangsQueryResponse,
} from "../../types/tagIdiomasController/GetApiV1TagTagidLangs.ts";
import { tagLangViewModelPaginatedResponseSchema } from "../tagLangViewModelPaginatedResponseSchema.ts";

export const getApiV1TagTagidLangsPathParamsSchema = z.object({
  tagId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1TagTagidLangsPathParams>;

export const getApiV1TagTagidLangsQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1TagTagidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagTagidLangs200Schema = z.lazy(
  () => tagLangViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1TagTagidLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagTagidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1TagTagidLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagTagidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangs500>;

export const getApiV1TagTagidLangsQueryResponseSchema = z.lazy(
  () => getApiV1TagTagidLangs200Schema,
) as unknown as ToZod<GetApiV1TagTagidLangsQueryResponse>;
